var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("SQL Reports")]),_c('SQLReport',{model:{value:(_vm.selectedReport),callback:function ($$v) {_vm.selectedReport=$$v},expression:"selectedReport"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }